/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Input, InputSelect, Label, Button, CustomLoading, SaveIcon } from "../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../Services/partscommandService";

/* 🧠 REDUX */
/* ⚙ CONFIG*/
/* 📁 ASSETS*/
import { Excluir } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, TitleContainer, Title, ContainerRow, ContainerColumn, ImageIcon, ButtonsContainer } from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../util/validate";

const ViewPartsComands = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    document.title = "Edição de Part Command";
    const [loading, setLoading] = useState(true);

    let { id } = useParams();
    const Services = useRef(new PartsComandServices());

    const NameField = useRef();
    const CommandField = useRef();
    const default_categoryField = useRef();
    const switch_variableField = useRef();

    const Namevalue = useRef();
    const Commandvalue = useRef();
    const default_categoryvalue = useRef();
    const switch_variablevalue = useRef();
    
    const [partCommand, setPartCommand] = useState();
    const [defaultCategories, setDefaultCategories] = useState([]);
    const [variables, setVariables] = useState([]);

    useEffect(() => {
        async function getPartCommand(){
            setLoading(true)
            let currentItem = await Services.current.getPartCommand(id);
            if(currentItem){
                setPartCommand(currentItem);
            }
            setLoading(false)
        }

        async function getDefaultCategories(){
            let currentList = await Services.current.getDefaultCategories();
            setDefaultCategories(currentList)
        }

        async function getPartCommandsVariables(){
            let currentList = await Services.current.getPartCommandsVariables();
            setVariables(currentList)
        }

        getPartCommand();
        getPartCommandsVariables();
        getDefaultCategories();
    }, [id]);

    // method-spoofing
    // Salva as edições
    async function Save(){
        if(isValidField(Namevalue.current) && isValidField(Commandvalue.current) && isValidField(default_categoryvalue.current)){
            let form = new FormData();
            if(Namevalue.current){form.append('name', Namevalue.current)}
            if(Commandvalue.current){form.append('Command', Commandvalue.current)}
            if(default_categoryvalue.current){form.append('default_category', default_categoryvalue.current)}
            if(switch_variablevalue.current){form.append('switch_variable', switch_variablevalue.current)}
            form.append('_method', 'PATCH')

            let currentitem = await Services.current.editPartCommand(id, form)
            if(currentitem){
                setPartCommand(currentitem);
            }
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return (
        <>  
            <Container>
                <TitleContainer>
                    <Title>{partCommand?.name}</Title>
                </TitleContainer>

                {loading ? <CustomLoading width={'150px'} height={'150px'}/>:
                <>
                    <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={t("inputs.name.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='name' 
                                name='name' 
                                type="text" 
                                placeholder= {t("inputs.name.placeholder")}
                                innerRef={NameField}
                                value={partCommand?.name}
                                invalidMessage = {t("inputs.name.invalid-message")}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => Namevalue.current = text}> 
                            </Input>
    
                            <Label text={"Command"} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='Command' 
                                name='Command' 
                                type="text" 
                                placeholder= {"Command"}
                                innerRef={CommandField}
                                value={partCommand?.command}
                                invalidMessage = {"Command inválido!"}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => Commandvalue.current = text}> 
                            </Input>
                                                
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={"Categoria padrão"} aling="flex-start"/>
                            <InputSelect
                                key={'default_category'}
                                name={'default_category'}
                                id={'default_category'}
                                placeholder={"Categoria padrão"}
                                invalidMessage = {"Categoria padrão inválida!"}
                                options={defaultCategories}
                                innerRef={default_categoryField}
                                value={partCommand?.default_category}
                                validationFunction = {(value) => isValidField(value)}
                                onchange={(value) => default_categoryvalue.current = value}>
                            </InputSelect>
                            
                            <Label text={"Variável de estado"} aling="flex-start"/>
                            <InputSelect 
                                key={'switch_variable'}
                                id='switch_variable' 
                                name='switch_variable' 
                                placeholder= {"Variável de estado"}
                                options={variables}
                                innerRef={switch_variableField}
                                value={partCommand?.switch_variable}
                                invalidMessage = {"Variável de estado inválida!"}
                                validationFunction = {(text) => isValidField(text)}
                                onchange={(text) => switch_variablevalue.current = text}> 
                            </InputSelect>
                        </ContainerColumn>
                    </ContainerRow>

                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                        <Button text={t("buttons.delete")} width={'150px'} color={'white-red'} onClick={async function(){
                            await Services.current.deletePartCommand(id);
                            navigate('/PartCommands')
                        }} icon={<ImageIcon src={Excluir}/>}/>
                    </ButtonsContainer>
                </>}

            </Container>
        </>
    );
}

export default ViewPartsComands;